module.exports = __webpack_public_path__ + "static/artsy.ad0ebfaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/artsy.png
// module id = 839
// module chunks = 73261030922168